import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Button } from './ui/Button';

interface NotFoundProps {
  message?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

/**
 * Not Found component for 404 / empty states
 * 
 * Design: Matches Ministry of Wine design system
 * - Icon: neutral-300 (light gray)
 * - Title: neutral-900 (dark)
 * - Message: neutral-600 (medium gray)
 * - Uses Button component with ghost and primary variants
 */
export const NotFound: React.FC<NotFoundProps> = ({ message = 'Resource not found', action }) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] px-4">
      <div className="text-center max-w-md">
        {/* Icon */}
        <AlertTriangle
          className="h-24 w-24 text-neutral-300 mx-auto mb-6"
          strokeWidth={1.5}
          aria-hidden="true"
        />
        
        {/* Title */}
        <h2 className="text-2xl font-bold text-neutral-900 mb-2">Not Found</h2>
        
        {/* Message */}
        <p className="text-base text-neutral-600 mb-6">{message}</p>
        
        {/* Actions */}
        <div className="flex gap-3 justify-center">
          <Button variant="ghost" onClick={() => navigate(-1)}>
            Go Back
          </Button>
          {action && (
            <Button variant="primary" onClick={action.onClick}>
              {action.label}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
